import axios from "axios";

export const state = {
    accountbalances: [],
};

export const getters = {
    accountbalances: state => state.accountbalances,
};

export const mutations = {
    setAccountBalances(state, newValue) {
        state.accountbalances = newValue
    },
};

export const actions = {
    async fetchAccountBalances({ commit, rootState }) {
        const fyear = rootState.financialyears.currentFinancialYear;
        await axios.get(`/accountbalances/${fyear}`).then(res => {
            commit('setAccountBalances', res.data.balances)
        })
    },
};
